import React, { useState, useContext } from 'react';
import 'bulma/css/bulma.min.css';

import { BeamlineContext } from '../../beamlineProvider.tsx';
import { Uid } from "./../../utils.tsx";


interface RemoveParameterSettingsProps {
  selection: Uid[];
}

const RemoveParameterSettings: React.FC<RemoveParameterSettingsProps> = (props) => {

  const beamlineContext = useContext(BeamlineContext);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [inProgress, setInProgress] = useState<boolean>(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(null);


  function clickedOpen() {
    if (!inProgress && !isOpen && props.selection.length > 0) {
      setIsOpen(true);
    }
  }

  async function pressedSubmit() {
    setSubmitErrorMessage(null);
    setInProgress(true);
    const result = await beamlineContext.scanTypes.deleteParameterSettingsFromServerAndRemove(props.selection);
    beamlineContext.changed();
    setInProgress(false);
    if (!result.success) {
      setSubmitErrorMessage(result.message || "");
    } else {
      setIsOpen(false);
    }
  };

  function clickedClose() {
    if (!inProgress) { setSubmitErrorMessage(null); setIsOpen(false); }
  }

  const plural = props.selection.length > 1 ? "s" : "";

  return (
    <a className="dropdown-item" onClick={ clickedOpen }>Remove Parameter{ plural }

      <div id="modal-add-sample" className={ isOpen ? "modal is-active" : "modal" }>
        <div className="modal-background"></div>

        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Remove Parameter{ plural }</p>
            <button className="delete" aria-label="close" onClick={ clickedClose }></button>

          </header>
          <section className="modal-card-body">

            <div className="block">
              <p>
                Are you sure you want to remove { props.selection.length } parameter{ plural } from the Scan Type?
              </p>
            </div>
            <div className="block">
              <p>
                <b>This operation cannot be undone!</b>
              </p>
            </div>

            <div className="buttons">
              <input
                type="button"
                className="button is-danger"
                onClick={ pressedSubmit }
                disabled={ inProgress }
                value="Delete"
              />
              <button className="button" onClick={ clickedClose }>Cancel</button>
            </div>

            { submitErrorMessage && (
              <article className="message is-danger">
                <div className="message-body">
                  { submitErrorMessage }
                </div>
              </article>
            )}

          </section>

        </div>
      </div>

    </a>
  )
}
export default RemoveParameterSettings
